export function wishlistCount(element, opts = {}) {
  const defaults = {
    updateEvent: 'wishlist:updated',
    countUpdateEvent: 'wishlist:count:updated',
    countRemovedEvent: 'wishlist:count:removed',
    activeClass: 'has-items',
    storageKey: 'wishlist_count',
  };

  if (!element) {
    return null;
  }

  const options = {
    ...defaults,
    ...opts,
    ...element.dataset,
  };

  bindEventListeners();
  update();

  function bindEventListeners() {
    document.addEventListener(options.updateEvent, handleWishlistUpdated);
  }

  function removeEventListeners() {
    document.removeEventListener(options.updateEvent, handleWishlistUpdated);
  }

  function handleWishlistUpdated() {
    update();
  }

  /**
   * @param {Boolean} state
   */
  function decorateElement(state = false) {
    element.classList.toggle(options.activeClass, state);
  }

  function update() {
    return window._swat.wishlistCount(result => {
      const count = parseInt(result, 10);

      decorateElement(count > 0);
    });
  }

  function destroy() {
    removeEventListeners();
  }

  return {
    destroy,
  };
}
